/* eslint-disable no-param-reassign */
import features from '@common/constants/features';

export default {
  namespaced: true,

  state: () => ({
    orders: [],
    ordersForReview: [],
    ordersForNotifications: [],
    loadProgress: false,
    loadNotificationsProgress: false,
    ordersCount: 0,
    totalPages: 0,
    pageSize: 10,
    page: 0, // номер следующей
  }),

  getters: {
    orders: (state) => state.orders,
    ordersCount: (state) => state.ordersCount,
    loadProgress: (state) => state.loadProgress,
    loadNotificationsProgress: (state) => state.loadNotificationsProgress,
    end: (state) => state.page >= state.totalPages,
    ordersForReview: (state) => state.ordersForReview,
    ordersForNotifications: (state) => state.ordersForNotifications,
  },

  mutations: {
    appendOrders: (state, orders = []) => {
      state.orders = [...state.orders, ...orders];
    },

    setOrdersForReview(state, orders = []) {
      state.ordersForReview = orders;
    },

    setOrderStatus: (state, orderNumber) => {
      state.orders = state.orders.map((order) => {
        if (order.orderNumber === orderNumber) {
          // TODO: Покрыть в тестах из-за бага https://jira.app.local/browse/ESMFUN-1662
          // TODO: в bff помержить эти поля, уже всплывал баг из-за путаницы
          order.currentStatus = 'cancelled';
          order.status = 'cancelled';
        }
        return order;
      });
    },

    setOrdersCount: (state, quantity = 0) => {
      state.ordersCount = quantity;
    },

    // TODO: почему это не геттер?
    setTotalPages: (state) => {
      // в методе нет параметра totalPages, поэтому считаем сами
      state.totalPages = Math.ceil(state.ordersCount / state.pageSize);
    },

    setLoadProgress: (state, loadProgress = true) => {
      state.loadProgress = loadProgress;
    },

    setLoadNotificationsProgress: (state, loadNotificationsProgress = true) => {
      state.loadNotificationsProgress = loadNotificationsProgress;
    },

    setPage: (state, page = state.page + 1) => {
      state.page = page;
    },

    setOrdersForNotifications(state, { orders = [] }) {
      state.ordersForNotifications = orders;
    },
  },

  actions: {
    loadOrders({ state, commit, rootGetters }) {
      if (state.loadProgress) return;
      commit('setLoadProgress');

      return this.$api.getOrders({
        pageNumber: state.page,
        pageSize: state.pageSize,
        withReceipts: rootGetters['features/$isFeatureEnabled'](features.OFFLINE_ORDER_RECEIPTS),
      })
        .then(({ orders = [], quantity = 0 }) => {
          commit('setOrdersCount', quantity);
          commit('setTotalPages');
          commit('appendOrders', orders);
          commit('setPage');
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          commit('setLoadProgress', false);
        });
    },

    async fetchOrdersForReview({ commit }) {
      const { orders = [] } = await this.$apiBFF.fetchReviewsAvailability();

      commit('setOrdersForReview', orders);
    },

    async fetchOrdersForNotifications({ state, commit, rootGetters }) {
      if (!rootGetters['features/$isFeatureEnabled'](features.ACTIVE_ORDERS_WIDGET) || state.loadNotificationsProgress) {
        return;
      }

      commit('setLoadNotificationsProgress');

      try {
        const notificationsOrders = await this.$apiBFF.fetchNotificationsOrders();

        commit('setOrdersForNotifications', notificationsOrders);
      } finally {
        commit('setLoadNotificationsProgress', false);
      }
    },

    updateOrderStatus({ commit }, orderNumber) {
      commit('setOrderStatus', orderNumber);
    },
  },
};
